<div>
	<div class="input-wrapper" data-cy="ui-select-input-wrapper">
		<div
			class="input outline-none"
			[class]="{
				'cursor-pointer': !disabled(),
				'cursor-not-allowed': disabled(),
				'input-focused': opened() || focused(),
				'input-disabled': disabled(),
				'input-error': hasError(),
				'input-valid': !hasError() && showWhenValid(),
			}"
			[id]="inputId()"
			[tabindex]="disabled() ? -1 : tabindex()"
			(keydown)="onKeyDown($event)"
			(focus)="onFocus()"
			(blur)="onBlur()"
			data-cy="ui-select-input"
		>
			@if (searchOpen()) {
				<ng-content></ng-content>
			} @else {
				<div class="input-field flex mr-1" [attr.data-cy]="'ui-select-input-input-field'">
					@if (value()) {
						<span
							class="whitespace-nowrap overflow-hidden text-ellipsis grow user-select-none"
							data-cy="ui-select-input-field-value"
						>
							@if (showAllSummary()) {
								{{ translatedAll() }}
							} @else {
								{{ value() }}
							}
						</span>
						@if (showOverflowPill()) {
							<ui-pill
								[value]="'+' + (amountSelected() - 1).toString()"
								class="flex items-center ml-2 mr-1"
								type="secondaryOutline"
								[disabled]="disabled()"
							></ui-pill>
						}
					} @else {
						<span class="text-secondary-400 line-clamp-1 text-ellipsis">{{ placeholder() }}</span>
					}
				</div>

				<div class="relative">
					@if (showClearButton()) {
						<ui-icon
							icon="x_cross"
							type="dark"
							[action]="true"
							[disabled]="disabled()"
							size="s"
							(iconClicked)="onClearSelection($event)"
						></ui-icon>
					} @else {
						<ui-icon
							icon="x_arrow_down"
							[disabled]="disabled()"
							class="duration-300"
							[class.rotate-180]="opened()"
							size="m"
						></ui-icon>
					}
				</div>
			}
		</div>
	</div>
</div>
